import { render, staticRenderFns } from "./afterSaleOrder.vue?vue&type=template&id=2bb9e463&scoped=true"
import script from "./afterSaleOrder.vue?vue&type=script&lang=js"
export * from "./afterSaleOrder.vue?vue&type=script&lang=js"
import style0 from "./afterSaleOrder.vue?vue&type=style&index=0&id=2bb9e463&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2bb9e463",
  null
  
)

export default component.exports